import { IconButton, XMarkExit } from '@effizency/efz-design-system';
import type { ReactNode } from 'react';

interface ICookieHeaderProps {
    title: ReactNode;
    close: () => void;
}

const CookieHeader = ({ title, close }: ICookieHeaderProps) => (
    <div className="cookie-consent-header">
        <IconButton variant="tertiary" size="xs" className="close-cookie" onClick={close} dataTestId="cookie-consent-close">
            <XMarkExit iconBtn size="xs" variant="tertiary" />
        </IconButton>
        <span>{title}</span>
    </div>
);

export default CookieHeader;
